export const SET_USERS = "lists/set_users";
export const ADD_USERS = "lists/add_users";
export const ADD_USER = "lists/add_user";
export const REPLACE_USER = "lists/replace_user";
export const REMOVE_USER = "lists/remove_user";

export const SET_SEARCH = "lists/set_search";
export const RESET_LISTS = "lists/reset_lists";
